/*
 *  Copyright (C) 2026 SimpliCity Digital Inc - All Rights Reserved
 */

import React, { useEffect, useRef } from "react";
import { useOrgSettings } from "hooks/use-org-settings.js";

const CityVizComponent = (props) => {
    
    const component = props.component;
    const { getOrgSettingsString } = useOrgSettings();
    const cityviz_domain = getOrgSettingsString("cityviz_domain") ?? "tour.cityviz.ca";

    const data_domain = component?.data_domain ?? cityviz_domain;
    const widget_type = component?.widget_type ?? "community-profile";
    // domain should not have https:// in the value
    const script_src = `https://${data_domain}/www/js/embed-cityviz.js`;
    const div_id = `cityviz-container-${widget_type}`;
    
    const containerRef = useRef(null);

    useEffect(() => {
        const scriptId = "embed-cityviz-widget";
        let script = document.getElementById(scriptId);

        const initializeWidget = () => {
            // Prevent duplicates: Clear the container before initializing
            if (containerRef.current) {
                containerRef.current.innerHTML = "";
            }

            if (window.embedCityViz) {
                window.embedCityViz(div_id, widget_type);
            }
        };

        if (!script) {
            // Create and inject the script if it doesn't exist
            script = document.createElement("script");
            script.src = script_src;
            script.id = scriptId;
            script.async = true;
            script.onload = initializeWidget;
            document.body.appendChild(script);
        } else {
            // If script is already there, just re-initialize
            initializeWidget();
        }

        // Cleanup function
        return () => {
            // We don't necessarily remove the script (to cache it), 
            // but we clear the container to prevent ghost instances.
            if (containerRef.current) {
                containerRef.current.innerHTML = "";
            }
        };
    }, []);

    return (
        <div
            ref={containerRef}
            className="cityviz-container"
            id={div_id}
            style={{ minHeight: "80px", width: "100%" }}
        ></div>
    );
};

export { CityVizComponent };
